export default __webpack_public_path__ + "static/indro-5d3086fa6b94da37f347fa3f7bdfb828.png";